const resolveStableRowIdentity = (item, index) => (
    item?._localId
    || item?.aEId
    || item?._id
    || item?.cyclosUserId
    || item?.cyclosUserName
    || item?.type
    || index
);

export const buildArrayRowKey = (item, index, prefix = "row") => (
    `${prefix}:${resolveStableRowIdentity(item, index)}`
);

export default buildArrayRowKey;
